import { computed } from "vue"
import { useRoute, useRouter } from "vue-router"

/**
 * Synchronise les tags sélectionnés avec `route.query.tags` (répété ou CSV selon le routeur).
 */
export function useQueryTags() {
    const route = useRoute()
    const router = useRouter()

    const selectedTags = computed({
        get(): string[] {
            const raw = route.query.tags
            if (!raw) return []
            if (Array.isArray(raw)) {
                return raw.filter(Boolean) as string[]
            }
            return String(raw)
                .split(",")
                .map((s) => s.trim())
                .filter(Boolean)
        },
        set(tags: string[]) {
            const next = { ...route.query } as Record<string, unknown>
            if (!tags.length) {
                delete next.tags
            } else {
                next.tags = tags
            }
            router.replace({ query: next })
        },
    })

    return { selectedTags }
}
